import {FilterItemDto} from "./misc";

export const verifiedOptions: FilterItemDto[] = [
  {
    id: 1,
    name: 'Verified',
    icon: {name: 'circle', fill: '#F1F5F9', stroke: 'currentColor', type: 'fas'},
    value: true,
    class: 'bg-blue-400 hover:bg-blue-500 text-white'
  },
  {
    id: 2,
    name: 'Not Verified',
    icon: {name: 'circle', fill: '#F1F5F9', type: 'far'},
    value: false,
    class: 'bg-red-400 hover:bg-red-500 text-white'
  },
];
